import { calculateQRReferenceChecksum } from "swissqrbill/utils";
export const FONT_SIZE_SMALL = 7;
export const FONT_SIZE = 9;
export const FONT_SIZE_BOLD = 10;
export const FONT_SIZE_TITLE = 15;
export const FONT_SIZE_HEADING = 12;
/**
 * We need to map the html string to a printable version. This object does not know about HTML at all.
 * @param htmlText
 */
let domParser = new DOMParser();
/**
 * Function for mapping rgb colors to hex colors for the pdf. It will return #000000 if no RGB value was found.
 * @param color
 * @returns
 */
function rgb2hex(color) {
    return `#${color.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)?.slice(1).map(n => parseInt(n, 10).toString(16).padStart(2, '0')).join('') || "000000"}`;
}
export function calculateFullQrReference(qrRef) {
    //Build the full qr ref with checksum
    return qrRef + calculateQRReferenceChecksum(qrRef);
}
export function transformHTMLToPrintValues(htmlText, configPage) {
    if (htmlText == null || htmlText.length <= 0)
        return [];
    var cleanerString = htmlText.replace(/\\n|\n/g, "");
    var htmlElement = domParser.parseFromString(cleanerString, 'text/html');
    const values = [];
    transformHtmlElementToPrintValue(htmlElement, configPage, 0, {}, values);
    //Debug log for printing
    //console.log(values);
    return values;
}
/**
 * Extraxt only the text from the html.
 * @param htmlText
 * @returns
 */
export function transformHTMLToString(htmlText) {
    if (htmlText == undefined || htmlText == null || htmlText.length <= 0)
        return "";
    var htmlElement = domParser.parseFromString(htmlText, 'text/html');
    return htmlElement.body.innerText || "";
}
function transformHtmlElementToPrintValue(node, configPage, level, props, values) {
    //Document does not have a tag?
    const tagName = node.nodeName ? node.nodeName.toLowerCase() : null;
    let localProps = { ...props };
    switch (tagName) {
        case "ul":
            //Add a new line for makingspace
            values.push({ text: "", newLine: true });
            //We must reset the liIndex
            if (level > 1) {
                localProps.liIndex = 1;
            }
            else {
                localProps.liIndex = undefined;
            }
            level += 1;
            localProps = { ...localProps, ulIndex: level, olIndex: undefined };
            break;
        case "ol":
            //Add a new line for makingspace
            values.push({ text: "", newLine: true });
            //We must reset the liIndex
            if (level > 1) {
                localProps.liIndex = 1;
            }
            else {
                localProps.liIndex = undefined;
            }
            level += 1;
            localProps = { ...localProps, ulIndex: undefined, olIndex: level };
            break;
        case "li":
            const liIndex = props.liIndex ? props.liIndex + 1 : 1;
            //We must set the value to the parent ol or ul tag as well otherwise the next li does not know about it.
            props.liIndex = liIndex;
            localProps = { ...localProps, liIndex: liIndex };
            break;
        case "span":
            let color = node.style.getPropertyValue("color");
            localProps = { ...localProps, color: color ? rgb2hex(color) : undefined };
            break;
        case "b":
        case "strong":
            localProps = { ...localProps, font: configPage.defaultFontBold };
            break;
        case "u":
            localProps = { ...localProps, underline: true };
            break;
        case "i":
        case "em":
            localProps = { ...localProps, oblique: 10 };
            break;
        case "img":
            let align = node.getAttribute("align"); //This prop is not visible on the HTML page its only in the data.
            //Transform the middle prop to center for pdf logic
            if (align == "middle") {
                align = "center";
            }
            values.push({
                text: "", imageUrl: node.getAttribute("src"),
                imgOWidth: Number(node.getAttribute("imgowidth")),
                imgOHeight: Number(node.getAttribute("imgoheight")),
                imageWSize: Number(node.getAttribute("imgwsize")),
                align: align,
                newLine: true
            });
            break;
        case "br":
            //Create a new line for a br element
            values.push({ ...localProps, text: "", newLine: true });
            break;
        case "h6":
            //Read out the alignment
            let headingAlignment = node.style.getPropertyValue("text-align") || "left";
            localProps = { ...localProps, fontSize: configPage.defaultFontSize + 2, align: headingAlignment };
            //Create a new line for a p element
            values.push({ ...localProps, text: "", newLine: true });
            break;
        case "p":
            //Read out the alignment
            let alignment = node.style.getPropertyValue("text-align") || "left";
            localProps = { ...localProps, align: alignment };
            //Create a new line for a p element
            values.push({ ...localProps, text: "", newLine: true });
            break;
    }
    if (node.childNodes.length > 0) {
        for (let index = 0; index < node.childNodes.length; index++) {
            const childNode = node.childNodes[index];
            transformHtmlElementToPrintValue(childNode, configPage, level, localProps, values);
        }
    }
    else if (node.nodeType == Node.TEXT_NODE) {
        if (node.textContent.length > 0) {
            values.push({ ...localProps, text: node.textContent });
        }
        //Debug log for printing
        //console.log(values[values.length - 1]);
    }
    if (tagName == "ul" || tagName == "ol") {
        //Add a new line for makingspace
        values.push({ text: "", newLine: true });
    }
}
export function calculateTableWidths(leftIndent, rightIndet, dist) {
    const maxWidth = 210;
    //Calc the max width we have
    const remainingSpace = maxWidth - leftIndent - rightIndet;
    const distribution = [];
    const onePercentrage = remainingSpace / 100;
    dist.forEach((dist, index) => {
        distribution[index] = dist * onePercentrage;
    });
    //Return the calculated values
    return distribution;
}
/**
 * Helper function to transform mm to pt
 * @param mm
 * @returns
 */
export function mmToPt(mm) {
    if (mm == null)
        return 0;
    if (mm >= 0) {
        return mm * 2.83465;
    }
    else {
        return 0;
    }
}
